import Menu, {MenuProps} from '@mui/material/Menu';
import MenuItem, {MenuItemProps} from '@mui/material/MenuItem';
import MenuList, {MenuListProps} from '@mui/material/MenuList';

import {styled} from '@mui/material/styles';

export const CMenu = styled(Menu)<MenuProps>(
  (/* { theme } */) => ({}),
);

export const CMenuItem = styled(MenuItem)<MenuItemProps>(
  (/* { theme } */) => ({}),
);

export const CMenuList = styled(MenuList)<MenuListProps>(
  (/* { theme } */) => ({}),
);
